import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgUst = function SvgUst(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#2D46A9",
        d: "M54.784 101.535c-6.255-9.175-1.911-18.072 1.043-21.374 2.92-3.336 10.253-7.646 13.554-9.383 13.555 3.127 40.768 10.217 41.185 13.554.521 4.17-2.607 7.692-8.341 13.033-5.735 5.341-21.896 17.724-27.63 18.767-5.735 1.043-11.99-3.128-19.81-14.597M37.06 40.54c-7.508-3.753-11.47-14.075-12.512-18.767-1.738.522-4.38.105-1.043-5.734C27.675 8.74 61.04-1.165 81.893 7.176c16.682 6.673 21.896 14.945 22.417 18.247-19.289 6.603-59.744 18.871-67.25 15.118"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6294F1",
        d: "M21.904 67.08C16.899 60.407 7.307 46.922 3.136 41.014 2.093 43.794.008 50.919.008 57.174c0 7.82-.521 22.939 6.777 35.972 5.84 10.426 21.2 19.984 28.152 23.459.695-2.259 1.772-8.758.521-16.682-1.564-9.905-7.298-24.502-13.554-32.843M34.937 53.526C28.68 39.97 41.714 29.023 51.097 23.81c5.909-3.128 20.75-9.384 32.844-9.384 15.118 0 24.502 9.384 30.237 22.938 5.734 13.555 8.862 34.408 1.564 43.27-7.299 8.863-27.11 2.085-35.45-1.564s-39.1-11.99-45.355-25.544M27.117 28.502c-7.507 3.754-17.03 6.082-20.853 6.777 2.085-3.823 7.299-12.511 11.47-16.682C22.945 13.384 32.85 7.649 39.106 7.649s4.692 5.735 2.607 8.863-5.213 7.298-14.597 11.99M80.292 114.52c-2.92-3.336 2.606-9.731 5.734-12.511 4.588-3.337 19.289-8.69 26.066-10.948-2.606 3.997-9.071 13.033-14.075 17.203-6.256 5.214-14.076 10.427-17.725 6.256"
    })));
};

export { SvgUst as ReactComponent };
//# sourceMappingURL=UST.svg.es.js.map
